var render = function render(){var _vm=this,_c=_vm._self._c;return _c('transition',{attrs:{"name":"fade"}},[_c('div',{staticClass:"x-switch",class:[
            { 'x-switch-checked': _vm.value, 'x-switch-disabled': _vm.disabled }
        ],attrs:{"tabindex":_vm.disabled ? -1 : _vm.tabindex},on:{"click":_vm.toggleSwitch,"keydown":function($event){if(!$event.type.indexOf('key')&&_vm._k($event.keyCode,"space",32,$event.key,[" ","Spacebar"]))return null;$event.preventDefault();return _vm.toggleSwitch.apply(null, arguments)}}})])
}
var staticRenderFns = []

export { render, staticRenderFns }